'use client';

import React, { useState, useEffect } from 'react';
import Icon from '@/components/ui/AppIcon';

interface SearchBarProps {
  onSearch: (query: string) => void;
  placeholder?: string;
}

const SearchBar = ({ onSearch, placeholder = 'Search by name or characteristics...' }: SearchBarProps) => {
  const [searchQuery, setSearchQuery] = useState('');
  const [isHydrated, setIsHydrated] = useState(false);

  React.useEffect(() => {
    setIsHydrated(true);
  }, []);

  const handleSearchChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const value = e.target.value;
    setSearchQuery(value);
    onSearch(value);
  };

  const handleClearSearch = () => {
    setSearchQuery('');
    onSearch('');
  };

  if (!isHydrated) {
    return (
      <div className="relative">
        <div className="h-12 w-full rounded-md border border-border bg-input" />
      </div>
    );
  }

  return (
    <div className="relative">
      <div className="pointer-events-none absolute inset-y-0 left-0 flex items-center pl-4">
        <Icon name="MagnifyingGlassIcon" size={20} variant="outline" className="text-muted-foreground" />
      </div>
      <input
        type="text"
        value={searchQuery}
        onChange={handleSearchChange}
        placeholder={placeholder}
        className="h-12 w-full rounded-md border border-border bg-input pl-12 pr-12 text-foreground transition-smooth placeholder:text-muted-foreground hover:border-primary/30 focus:outline-none focus:ring-3 focus:ring-ring focus:ring-offset-3"
      />
      {searchQuery && (
        <button
          onClick={handleClearSearch}
          className="absolute inset-y-0 right-0 flex items-center pr-4 text-muted-foreground transition-smooth hover:text-foreground"
          aria-label="Clear search"
        >
          <Icon name="XMarkIcon" size={20} variant="outline" />
        </button>
      )}
    </div>
  );
};

export default SearchBar;